"use strict";

exports.__esModule = true;
exports.FullSliderContainer = exports.FeatureTitleContainer = exports.SideBanner = exports.FeaturedBanner = exports.FeatureBorder = exports.Caption = exports.FullContainer = exports.FeatureSliderContainer = exports.ButtonContainer = exports.SliderActions = exports.SeeAll = exports.FeatureLabel = exports.CarouselContainer = exports.FeatureContainer = exports.FeatureTitle = exports.SliderContainer = exports.SliderChild = exports.MainContainer = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _theme = _interopRequireDefault(require("./theme"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _templateObject18() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  & > .slick-slider > .slick-dots {\n    bottom: ", ";\n  }\n  & > .slick-slider > .slick-dots li {\n    width: ", ";\n  }\n  & > .slick-slider > .slick-dots li button {\n    width: ", ";\n  }\n  & > .slick-slider > .slick-dots li button:before {\n    color: ", ";\n    width: ", ";\n    font-size: ", ";\n  }\n  & > .slick-slider > .slick-dots li.slick-active button:before {\n    color: ", ";\n  }\n"]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteralLoose(["\n\n"]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  z-index: 10;\n  overflow: hidden;\n  display: flex;\n  justify-content: center;\n  height: auto;\n  width: 100%;\n  @media (min-width: 768px ) {\n    height: 39.8rem;\n    width: 100%;\n    object-fit: cover;\n  }\n"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteralLoose(["\n  padding-left: ", ";\n  border-left: ", ";\n  margin-bottom: 3.6rem;\n  width: 32rem;\n  @media (max-width: 767px) {\n    padding: ", ";\n    border-left: none;\n    display: flex;\n    flex-direction: ", ";\n    width: 100%;\n    margin-bottom: ", ";\n    align-items: ", ";\n    justify-content: ", ";\n  }\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: 1.6rem;\n  line-height: 2.4rem;\n  padding-bottom: ", ";\n  @media (min-width: 768px) {\n    padding-bottom: 1.6rem;\n  }\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteralLoose(["\n  padding: 0.7rem;\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  padding-left: ", ";\n  @media (max-width: 767px) {\n    display: none;\n  }\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: 1.6rem;\n  letter-spacing: 0;\n  line-height: 1.6rem;\n  cursor: pointer;\n  @media (max-width: 767px) {\n    padding-top: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    &::after {\n      content: \" >\"\n    }\n  }\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  padding-right: ", ";\n  box-sizing: content-box;\n  z-index: 100;\n  color: ", ";\n  padding-top: 12rem;\n  @media (max-width: 767px) {\n    padding-top: ", ";\n    width: 100%;\n    padding-right: 0;\n  }\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  width: 100%;\n  padding-top: ", ";\n  @media (max-width: 767px) {\n    padding-top: 0;\n  }\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 100%;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n  max-width: 140rem;\n  display: flex;\n  flex-direction: row;\n  background-color: ", ";\n  align-items: ", ";\n  margin: 0 auto;\n  padding: ", ";\n  @media (min-width: 768px) {\n    background: ", ";\n    background-size: contain;\n    padding: ", ";\n    background-color: ", ";\n  }\n  @media (max-width: 1400px) {\n    padding: ", ";\n  }\n  @media (max-width: 767px) {\n    background-color: ", ";\n    padding: ", ";\n    flex-direction: column;\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: 3.2rem;\n  font-weight: 700;\n  text-align: left;\n  line-height: 4.4rem;\n  padding-bottom: 1.4rem;\n  @media (max-width: 767px) {\n    padding-bottom: 0rem;\n    font-size: 22px;\n    line-height: 3.2rem;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding: 0 1.2rem 0 0;\n  @media (min-width: 768px) {\n      flex-direction: column;\n      padding: 0;\n      justify-content: center;\n      align-items: flex-start;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  max-width: 140rem;\n  margin: 0 auto;\n  & > .slick-slider {\n    z-index: 100;\n  }\n  & > .slick-slider > .slick-list {\n    overflow: hidden;\n    box-sizing: content-box;\n    height: 100% !important;\n  }\n  & > .slick-slider > .slick-prev {\n    left: 0;\n    z-index: 100;\n  }\n  & > .slick-slider > .slick-next {\n    right: 0;\n    z-index: 100;\n  }\n  & > .slick-slider > .slick-list > .slick-track {\n    width: ", ";\n  }\n  & > .slick-slider > .slick-list > .slick-track > .slick-slide {\n    padding-right: 1rem;\n    @media (min-width: 768px) {\n      padding-right: 1.6rem;\n    }\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  max-width: 140rem;\n  margin: 0 auto;\n  & > .slick-slider {\n    z-index: 100;\n  }\n  & > .slick-slider > .slick-list {\n    overflow: hidden;\n    box-sizing: content-box;\n    padding: 1rem;\n    height: 100% !important;\n    @media (max-width: 1399px) {\n      overflow: visible;\n    }\n  }\n  & > .slick-slider > .slick-prev {\n    left: 0;\n    z-index: 100;\n  }\n  & > .slick-slider > .slick-next {\n    right: 0;\n    z-index: 100;\n  }\n  & > .slick-slider > .slick-list > .slick-track {\n    width: ", ";\n  }\n  & > .slick-slider > .slick-list > .slick-track > .slick-slide {\n    padding-right: 1rem;\n    @media (min-width: 768px) {\n      padding-right: 1.6rem;\n    }\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  margin: 0 auto;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  outline: none;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var SliderChild = _styledComponents["default"].div(_templateObject());

exports.SliderChild = SliderChild;

var MainContainer = _styledComponents["default"].div(_templateObject2());

exports.MainContainer = MainContainer;

var SliderContainer = _styledComponents["default"].div(_templateObject3(), function (props) {
  return props.slides > props.items ? "255rem !important" : props.itemWidth && props.items * props.itemWidth + "px !important";
});

exports.SliderContainer = SliderContainer;

var FeatureSliderContainer = _styledComponents["default"].div(_templateObject4(), function (props) {
  return props.slides > props.items ? "255rem !important" : props.itemWidth && props.items * props.itemWidth + "px !important";
});

exports.FeatureSliderContainer = FeatureSliderContainer;

var FeatureTitleContainer = _styledComponents["default"].div(_templateObject5());

exports.FeatureTitleContainer = FeatureTitleContainer;

var FeatureTitle = _styledComponents["default"].div(_templateObject6());

exports.FeatureTitle = FeatureTitle;

var FeatureContainer = _styledComponents["default"].div(_templateObject7(), function (props) {
  return props.fullColor;
}, function (props) {
  return props.banner ? "flex-start" : "center";
}, function (props) {
  return props.fullColor ? "5rem 0rem" : "0";
}, function (props) {
  return props.sideBanner && "url('" + props.sideBanner + "') no-repeat " + props.fullColor;
}, function (props) {
  return props.padding;
}, function (props) {
  return props.banner ? "#FFF" : props.fullColor && props.fullColor;
}, function (props) {
  return props.padding ? props.padding : "0 0 0 2rem";
}, function (props) {
  return props.fullColor;
}, function (props) {
  return props.mobilePadding ? props.mobilePadding : "0 0 0 2rem";
});

exports.FeatureContainer = FeatureContainer;

var FullContainer = _styledComponents["default"].div(_templateObject8());

exports.FullContainer = FullContainer;

var CarouselContainer = _styledComponents["default"].div(_templateObject9(), function (props) {
  return props.banner ? "25rem" : 0;
});

exports.CarouselContainer = CarouselContainer;

var FeatureLabel = _styledComponents["default"].div(_templateObject10(), function (props) {
  return props.labelPadding ? props.labelPadding : '3.2rem';
}, function (props) {
  return props.fontColor ? props.fontColor : props.banner ? "#fff" : "#3e3f42";
}, function (props) {
  return props.banner ? "6rem" : 0;
});

exports.FeatureLabel = FeatureLabel;

var SeeAll = _styledComponents["default"].div(_templateObject11(), function (props) {
  return props.hasBanner ? "0" : ".8rem";
}, function (props) {
  return props.hasCaption ? "1.6rem" : "1.6rem";
}, function (props) {
  return props.hasCaption ? "1.6rem" : "1.6rem";
});

exports.SeeAll = SeeAll;

var SliderActions = _styledComponents["default"].div(_templateObject12(), function (props) {
  return props.border ? "3.7rem" : props.hasCaption ? "3.7rem" : "0";
});

exports.SliderActions = SliderActions;

var ButtonContainer = _styledComponents["default"].div(_templateObject13());

exports.ButtonContainer = ButtonContainer;

var Caption = _styledComponents["default"].div(_templateObject14(), function (props) {
  return props.hasBanner && props.hasSeeAll ? '1rem' : 0;
});

exports.Caption = Caption;

var FeatureBorder = _styledComponents["default"].div(_templateObject15(), function (props) {
  return props.border ? "3.7rem" : props.hasCaption ? "3.7rem" : "0";
}, function (props) {
  return props.border && ".6rem solid " + props.border;
}, function (props) {
  return props.hasBanner ? "0 1rem 0 1rem" : "0";
}, function (props) {
  return props.hasCaption ? "column" : "row";
}, function (props) {
  return props.hasCaption && props.hasSeeAll ? "2rem" : "1.6rem";
}, function (props) {
  return props.hasCaption ? "flex-start" : "center";
}, function (props) {
  return props.hasCaption ? "flex-start" : "space-between";
});

exports.FeatureBorder = FeatureBorder;

var FeaturedBanner = _styledComponents["default"].img(_templateObject16());

exports.FeaturedBanner = FeaturedBanner;

var SideBanner = _styledComponents["default"].img(_templateObject17());

exports.SideBanner = SideBanner;

var FullSliderContainer = _styledComponents["default"].div(_templateObject18(), function (props) {
  return props.dotsBottomOffset ? props.dotsBottomOffset : '-2.5rem';
}, function (props) {
  return props.dotsWidth ? props.dotsWidth : '2rem';
}, function (props) {
  return props.dotsWidth ? props.dotsWidth : '2rem';
}, function (props) {
  return props.dotsPassiveColor ? props.dotsPassiveColor : '#000';
}, function (props) {
  return props.dotsWidth ? props.dotsWidth : '2rem';
}, function (props) {
  return props.dotsFontSize ? props.dotsFontSize : '.6rem';
}, function (props) {
  return props.dotsActiveColor ? props.dotsActiveColor : '#000';
});

exports.FullSliderContainer = FullSliderContainer;